// extracted by mini-css-extract-plugin
module.exports = {"popUpSubMenu":"PopUpSubMenu_popUpSubMenu__QbhP7","title":"PopUpSubMenu_title__3Uwwi"};